import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SafeHTML from "../SafeHTML";
import style from '../../../scss/components/Products/ProductIntro';
export default class ProductIntro extends React.Component {
  static propTypes = {
    headline: PropTypes.string,
    description: PropTypes.string
  };
  render() {
    return (
      <section className="intro-section">
				<div className="container">
					<h2 className="intro-title">{this.props.headline}</h2>
					<div className="intro-content">
						<SafeHTML>{this.props.description}</SafeHTML>
					</div>
				</div>
      </section>
    );
  }
}
